import { createSlice } from "@reduxjs/toolkit";
import { Question } from "interfaces";

const initialState = {
  filters: {
    projectId: "",
    pageIndex: 1,
    pageSize: 100,
  },
  chatHistory: {
    hasNextPage: true,
    hasPreviousPage: false,
    pageNumber: 1,
    totalCount: 0,
    totalPages: 0,
    items: [] as Question[],
  },
  loading: false,
  waitMessage: false,
  newMessage: false,
  errorMessage: false,
  repliedAnswer: "",
  openChat: true,
  checkInactiveAnswers: false,
};
const gestioneChatSlice = createSlice({
  name: "gestioneChatSlice",
  initialState: initialState,
  reducers: {
    setPageChat: (state, action) => {
      Object.assign(state.filters, {
        pageIndex: action.payload,
      });
    },
    setProjectId: (state, action) => {
      Object.assign(state.filters, {
        projectId: action.payload,
      });
    },
    setChatHistory: (state, action) => {
      state.chatHistory = action.payload;
    },
    setRepliedAnswer: (state, action) => {
      state.repliedAnswer = action.payload;
    },
    addMessage: (state, action) => {
      state.chatHistory.items = [...state.chatHistory.items, action.payload];
    },
    setAnswer: (state, action) => {
      state.chatHistory.items[state.chatHistory.items.length - 1].id =
        action.payload.question.id;
      state.chatHistory.items[
        state.chatHistory.items.length - 1
      ].answersList.push(...action.payload.question.answersList);
    },
    setRefreshAnswer: (state, action) => {
      state.chatHistory.items[
        state.chatHistory.items.length - 1
      ].answersList.push(action.payload);
    },
    updateChatAnswerFeedback: (state: any, action: any) => {
      state.chatHistory.items = state.chatHistory.items.map((item: any) => {
        if (item.id === action.payload.questionId) {
          item.hasFeedback = true;
        }
        return item;
      });
    },
    setLoadingChatHistory: (state, action) => {
      state.loading = action.payload;
    },
    setWaitMessage: (state, action) => {
      state.waitMessage = action.payload;
    },
    setNewMessage: (state, action) => {
      state.newMessage = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setOpenChat: (state, action) => {
      state.openChat = action.payload;
    },
    setActionAnswer: (state, action) => {
      const { idQuestion, idAnswer, hasFeedback, isSaved } = action.payload;

      const question = state.chatHistory.items.find((q) => q.id === idQuestion);

      if (question) {
        const answer = question.answersList.find((a) => a.id === idAnswer);

        if (answer) {
          if (typeof hasFeedback !== "undefined") {
            answer.hasFeedback = hasFeedback;
          }

          if (typeof isSaved !== "undefined") {
            answer.isSaved = isSaved;
          }
        }
      }
    },
    resetStateChat: (state) => {
      return initialState;
    },
    setCheckInactiveAnswers: (state, action) => {
      state.checkInactiveAnswers = action.payload;
    }
  },
});
export const {
  setPageChat,
  addMessage,
  setAnswer,
  setProjectId,
  setChatHistory,
  setLoadingChatHistory,
  setRefreshAnswer,
  updateChatAnswerFeedback,
  setRepliedAnswer,
  setWaitMessage,
  setNewMessage,
  setActionAnswer,
  resetStateChat,
  setErrorMessage,
  setOpenChat,
  setCheckInactiveAnswers
} = gestioneChatSlice.actions;

export default gestioneChatSlice.reducer;
